import React, { Component } from 'react';

//componentes
import CopiaAgendaA from './copiaAgendaA'

class Index extends Component {

    render(){
        return(
            <div>
                <CopiaAgendaA />
            </div>
        );
    }

}
export default Index;